module.exports = __webpack_public_path__ + "static/media/dev-1.be699c47.png";